import { render, staticRenderFns } from "./qrCode.vue?vue&type=template&id=b2f7621c&scoped=true&"
import script from "./qrCode.vue?vue&type=script&lang=js&"
export * from "./qrCode.vue?vue&type=script&lang=js&"
import style0 from "./qrCode.vue?vue&type=style&index=0&id=b2f7621c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2f7621c",
  null
  
)

export default component.exports